import { getUserSettingsApi } from '@/api/common';
import store from '@/store';

export const getUserSettings = async (): Promise<void> => {
  const { data } = await getUserSettingsApi();

  store.commit('user/rewriteUserDataFromResponse', data);
  store.commit('lendio/rewriteLendioDataFromResponse', data);
};
